import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Header, Page } from 'components';
import { Card, CardContent } from '@mui/material';
import LockdownAggregationForm from './components/LockdownAggregationForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const LockdownAggregation = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Cluster Aggregation">
			<Header module="Cluster Aggregation" view="Management" />
			<Card className={classes.content}>
				<CardContent>
					<LockdownAggregationForm />
				</CardContent>	
			</Card>		
		</Page>
	);
};

export default LockdownAggregation;